module.exports = __webpack_public_path__ + "media/smb_pause.58953c32.flac";